// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Automation .card {
  border-radius: 1rem;
}
.Automation .card .card-header,
.Automation .card .card-body {
  padding-left: 0;
  padding-right: 0;
  margin-left: 2rem;
  margin-right: 2rem;
}
.Automation .card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: inherit;
  padding-top: 1.5rem;
  padding-bottom: 1rem;
}
.Automation .card .card-header:first-child {
  border-radius: 1rem 1rem 0 0;
}
.Automation .card .card-header .card-title {
  color: var(--bs-primary);
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/features/Automation/styles.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AACI;;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACN;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AACN;AAAM;EACE,4BAAA;AAER;AAAM;EACE,wBAAA;EACA,yBAAA;AAER","sourcesContent":[".Automation {\n  .card {\n    border-radius: 1rem;\n    .card-header,\n    .card-body {\n      padding-left: 0;\n      padding-right: 0;\n      margin-left: 2rem;\n      margin-right: 2rem;\n    }\n    .card-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      background-color: inherit;\n      padding-top: 1.5rem;\n      padding-bottom: 1rem;\n      &:first-child {\n        border-radius: 1rem 1rem 0 0;\n      }\n      .card-title {\n        color: var(--bs-primary);\n        text-transform: uppercase;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
